import React, {Fragment} from "react";

import {
	useLocalStore,
	Loaders,
	setupLoaders,
} from '../data';

import {
	Card,
	AddLink,
	LoadingSpinner,
	ErrorBoundary,
	Button,
	Modal,
	useRelayErrors,
	ErrorStripe,
	FormGroup,
	InputComponent,
	DeleteModalComponent,
	FunnelsListPickerApp,
} from './';

type Props = {
	close: () => void
	loading: boolean
	action: (a, b) => void
}

export function Connect(props: Props){
	const [onError, errors, setErrors] = useRelayErrors();
	const [state, onChange] = useLocalStore({
		token: "",
		shop: "",
		secret: "",
	});
	return (
		<Modal
			close={() => {
				props.close();
			}}
			title="Connect to Shopify"
			footer={
				<Fragment>
					<Button
						className="cancelButton"
						onClick={() => {
							props.close();
						}}
					>
						Cancel
					</Button>
					<Button
						children="Save"
						primary
						disabled={!state.token || !state.secret || !state.shop}
						spinning={props.loading}
						onClick={
							function () {
								if(props.loading){
									return;
								}
								setErrors([]);
								props.action(state, onError);
							}
						}
					/>
				</Fragment>
			}
		>
			{
				errors[""] && (
					<ErrorStripe message={errors[""]} />
				)
			}
			<div className="mb-2">Enter your Shopify store credentials to connect it to Lightfunnels.</div>

			<Video />

			<FormGroup label="Shopify store URL">
				<InputComponent
					placeholder="yourstore.myshopify.com"
					error={errors['shop']}
					onChange={onChange}
					value={state.shop}
					name="shop"
				/>
			</FormGroup>

			<FormGroup label="Access Token">
				<InputComponent
					placeholder=""
					error={errors['token']}
					onChange={onChange}
					value={state.token}
					name="token"
				/>
			</FormGroup>

			<FormGroup label="App Secret">
				<InputComponent
					placeholder=""
					error={errors['secret']}
					onChange={onChange}
					value={state.secret}
					name="secret"
				/>
			</FormGroup>
		</Modal>
	)
}

export function Video(){
	return (
		<iframe
			width="560"
			height="315"
			src="https://www.youtube.com/embed/ffG-aH5VcAM"
			className={"videoTuto"}
			title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
	)
}